<div class="result-popover">
  <ion-button fill="clear" [ngClass]="favProvider?'active':''" [style.color]="favProvider" class="pop-btn" (click)="favProv('favProvider')">
    @if (!favProvider) {
      <ion-icon name="heart-outline"></ion-icon>
    }
    @if (favProvider) {
      <ion-icon name="heart"></ion-icon>
    }
    Favourite Provider
  </ion-button>
  <ion-button fill="clear" class="pop-btn" (click)="favProv('compare')" [ngClass]="compare?'active':''">Add to Compare</ion-button>
</div>